const unleash = {
  url: import.meta.env.VITE_UNLEASH_PROXY_URL,
  clientKey: import.meta.env.VITE_UNLEASH_PROXY_SERVER_CLIENT,
  refreshInterval: 10,
  appName: 'R2-MyFinancial',
  environment: import.meta.env.VITE_UNLEASH_ENV,
  context: {
    country: localStorage.getItem('countryCode'),
  },
};

export default unleash;
